import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Routes from "./Routes";
import { AppContextProvider } from "./AppContext";
import { App, ConfigProvider } from "antd";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: "#9333ea",
      },
    }}
  >
    <App>
      <AppContextProvider>
        <Routes />
      </AppContextProvider>
    </App>
  </ConfigProvider>
);
